export class BaseElementModel {
}
